import { IAuditPrompt } from '../types/audit'

const AUDIT_PROGRESS = {
  needsCoaching: 'needs-coaching',
  completed: 'completed',
  coached: 'coached',
}

const AI_DECISION = {
  pass: 'pass',
  fail: 'fail',
} as const

export type AiDecision = (typeof AI_DECISION)[keyof typeof AI_DECISION]

enum AUDIT_KEYS {
  installation = 'installation',
  dvir = 'dvir',
  coaching = 'coaching',
  aiTraining = 'aiTraining',
  vanDown = 'vanDown', // Kept for Van Down queue (queries Vans, not Audits)
}

const AUDIT_NAMES: { [section in AUDIT_KEYS]: string } = {
  installation: 'Installation',
  dvir: 'DVIR',
  coaching: 'Coaching',
  aiTraining: 'AI Training',
  vanDown: 'Van Down',
}

const AUDIT_PATHS: { [section in AUDIT_KEYS]: string } = {
  installation: '/audits/installation',
  dvir: '/audits/dvir',
  coaching: '/audits/coaching',
  aiTraining: '/audits/ai-training',
  vanDown: '/audits/van-down',
}

const initialAuditNote: IAuditPrompt = {
  Notes: {
    value: '',
    textProps: {
      type: 'text',
      multiline: true,
      rows: 3,
    },
  },
}

export {
  AUDIT_PROGRESS,
  AI_DECISION,
  AUDIT_NAMES,
  AUDIT_PATHS,
  AUDIT_KEYS,
  initialAuditNote,
}
